import React, { useState, useEffect } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { Check } from "lucide-react"
import { useAppCtx } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { StatementsWrapper } from "./statements"

export default function DisputeElementManager(){

  const { dspid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams()
  
  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { _id: dspid })
  const { data:_Clients } = queryTools.resource.parseQueryForApi("client.findAll", {})
  const saveFn = queryTools.resource.save(["dispute"])

  const [ elementToEdit, setElementToEdit ] = useState<any>() 

  async function handleDisputeSave(e:any){
    e.preventDefault()
    const formData:any = new FormData(e.target)
    const data = Object.fromEntries(formData.entries())
    saveFn.mutate({ resource: "dispute", data: {...data, _id: _Dispute._id} })
  }

  useEffect(() => {
    if( searchParams.get("elem") ){
      setElementToEdit(searchParams.get("elem"))
    }
  },[searchParams.get("elem")])


  if( !_Dispute || !elementToEdit ) return <></>
  return (
    <div className="w-full h-full *:text-neutral-200">
      { (elementToEdit === "opening_statements" || elementToEdit === "compelling_evidence") && (
        <StatementsWrapper elemtype={elementToEdit} /> 
      )}
    </div>
  )
}